import AppLayout from '../../layouts/AppLayout/AppLayout';
import MainHeader from '../../Components/MainHeader/MainHeader';
import Registration from '../../Components/Auth/Registration/Registration';
import MainFooter from '../../Components/MainFooter/MainFooter';

function RegistrationPage() {
    return (
        <AppLayout>
            <MainHeader variant="cabinet" />
            <main>
                <Registration />
            </main>
            <MainFooter />
        </AppLayout>
    );
}

export default RegistrationPage;
